import React from "react";
import TicketList from "../../../components/management/ticket/ticket-list/TicketList";
import "./TicketRoute.scss";

export default class TicketRoute extends React.PureComponent {
  backPage() {}

  render(): React.ReactNode {
    return (
      <>
        <TicketList/>
      </>
    );
  }
}
